export default __webpack_public_path__ + "static/media/Experience_Flatgeneric.488b3ac4.png";